import React from "react";
import { Avatar, InfoText, InfoTextAdv } from "../../../../../components";

const InfoTextList = () => {
  return (
    <div className="w-full flex flex-col gap-10 py-5">
      <div className="flex gap-5 items-center">
        <InfoText title={"Reporting Manager"} value={""} />
        <InfoText title={"Project Manager"} value={"Project Manager Name"} />
      </div>
      <div className="flex gap-5 items-center">
        <InfoText icon={"chip_extraction"} value={""} />
        <InfoText icon={"open_run"} value={"1000"} />
      </div>
      <div className="flex gap-10 items-start">
        <InfoTextAdv
          title={"Created On"}
          titleProps={{ className: "!text-black" }}
          value={<h5 className="line-clamp-1 text-black">July 8, 2024</h5>}
        />
        <InfoTextAdv
          title={"Last Used"}
          titleProps={{ className: "!text-info" }}
          value={<h5 className="line-clamp-1 text-primary">October 9, 2024</h5>}
        />
        <InfoTextAdv
          title={"Modified On"}
          titleProps={{ className: "!text-black !text-2xl  font-bold" }}
          value={
            <p className="line-clamp-1 text-black text-xs">July 8, 2024</p>
          }
        />
      </div>
    </div>
  );
};

export default InfoTextList;
